import React from "react";
import { Link } from "react-router-dom";
import content from "../content/content.json";

const CapabilityAreasSection = () => {
  const { capabilityAreas } = content;

  return (
    <section className="w-full bg-white py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1C1F2B]">{capabilityAreas.heading}</h2>
          <p className="text-gray-600 text-lg mt-4">{capabilityAreas.subText}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {capabilityAreas.items.map((item) => (
            <Link key={item.id} to={item.href} className="group block">
              <article className="bg-white border border-gray-200 rounded-md overflow-hidden h-full flex flex-col transition-shadow duration-300 group-hover:shadow-md">
                <div className="h-52 w-full overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-6 flex flex-col gap-3 flex-grow">
                  <h3 className="text-2xl font-bold text-[#1C1F2B] leading-snug group-hover:text-[#E4002B] transition-colors duration-200">{item.title}</h3>
                  <p className="text-gray-600 text-base leading-relaxed">{item.description}</p>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CapabilityAreasSection;
